if (!customElements.get("loop-carousel")) {
  class LoopCarousel extends HTMLElement {
    constructor() {
      super();
      this.carouselItem = [
        ...this.querySelectorAll(".loop-carousel-row__item:not(.cloned)"),
      ];
      if (this.carouselItem.length < 1) {
        return;
      }
      
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.carousel = this.querySelector(".loop-carousel-row");
      this.carouselOuter = this.querySelector(".loop-carousel-container");
      this.carouselItem = this.carousel.children;
      if (this.dataset.navId)
        this.nav = document.querySelector(`#${this.dataset.navId}`);
      else
        this.nav = this.querySelector(".loop-carousel-nav");
      this.rtl = document.dir === "rtl";

      if (this.nav) {
        this.prevBtn = this.nav.querySelector('button[name="prev"]');
        this.nextBtn = this.nav.querySelector('button[name="next"]');
      }

      this.itemWidthBig = this.itemWidth = 32;
      this.itemPerRowBig = this.itemPerRow = 3;
      this.responsive = {
        1024: [2, 49],
        767: [3, 32],
        624: [2, 49],
        480: [1, 100],
      };
      this.gapWidth =
        (100 - this.itemPerRow * this.itemWidth) / (this.itemPerRow - 1) || 0; // prevent divide 0
      this.style.setProperty("--width", `${this.itemWidth}%`);
      this.style.setProperty("--margin", `${this.gapWidth}%`);

      this.initSlider();
      // setTimeout(()  => { this.initSlider(); }, 100); // wait for a while for the css to refresh
      
      window.addEventListener("on:debounced-resize", this.handleResize.bind(this));

      this.setAttribute("loaded", "");
    }

    initSlider() {
      this.index = 0;
      this.imgWidth = this.carouselItem[0].getBoundingClientRect().width;
      this.numberOfItem = this.carouselItem.length;
      this.step =
        this.imgWidth + (this.gapWidth / this.itemWidth) * this.imgWidth; //calculate the step to translate
      this.style.setProperty("--img-width", `${Math.round(this.imgWidth * 100) / 100}px`);

      this.canDrag = window.matchMedia("(pointer: fine)").matches || theme.device.hasTouch;
      this.loop = this.dataset.loop === "true";
      this.autoplay = this.dataset.autoplay === "true";

      if (this.loop) {
        this.cloneSlides();
      }

      if (this.autoplay) {
        this.initAutoplay();
      }

      if (this.canDrag) {
        this.firstPos = this.currentPos = 0;
        this.carouselOuter.classList.add("is-grabbable");
      }

      this.addListeners();

      if (this.nav) {
        this.setButtonStates();
      }

      this.handleResize();
    }

    translateSlide() {
      this.carousel.style.transform = `translate3d(${
        -this.index * this.step
      }px,0,0)`;
      //just a function used many time, to translate slide

      if (this.nav) {
        this.setButtonStates();
      }
    }

    cloneSlides() {
      //if loop is true, clone carousel item
      this.index = this.itemPerRow;
      this.translateSlide();
      for (let i = 0; i < this.itemPerRow; i++) {
        let cloneNode = this.carouselItem[i].cloneNode(true);
        cloneNode.classList.add('cloned');
        this.carousel.insertAdjacentElement("beforeend", cloneNode);
      }
      let count = 0;
      while (count != this.itemPerRow) {
        let cloneNode =
          this.carouselItem[this.numberOfItem - 1].cloneNode(true);
        cloneNode.classList.add('cloned');
        this.carousel.insertAdjacentElement("afterbegin", cloneNode);
        count++;
      }
    }

    resetSlide(step) {
      //reset slide, to make it loop
      if (this.index + step < 1) this.index = this.numberOfItem + 1;
      if (this.index + step >= this.numberOfItem + this.itemPerRow)
        this.index = this.itemPerRow - 1;
      this.carousel.style.transition = "none";
      this.translateSlide();
      //reset it silently by changing transition to none
      //then move it, i had delay 20ms because if we change inline style transition too fast, it will not work properly
      setTimeout(() => {
        this.carousel.style.transition = "all 0.25s";
        this.index += step;
        this.translateSlide();
      }, 20);
    }

    // this is to select the slide block in theme editor
    goToSlide(index) {
      this.carousel.style.transition = "all 0.25s";
      if (this.loop) {
        this.index = index + this.itemPerRow;
      } else {
        if (this.itemPerRow >= this.numberOfItem)
          this.index = 0;
        else if (index + this.itemPerRow > this.numberOfItem)
          this.index = this.numberOfItem - this.itemPerRow; // if the slide block is the last few items (to prevent showing empty spaces)
        else
          this.index = index;
      }
      this.translateSlide();
    }

    moveSlide(step) {
      this.carousel.style.transition = "all 0.25s";
      //every time we move slide, add transition
      if (this.loop) {
        if (
          this.index + step < 1 ||
          this.index + step >= this.numberOfItem + this.itemPerRow
        ) {
          this.resetSlide(step);
        } else {
          this.index += step;
          this.translateSlide();
        }
      } else {
        if (
          this.index + step < 0 ||
          this.index + step > this.numberOfItem - this.itemPerRow
        )
          return;
        else {
          this.index += step;
          this.translateSlide();
        }
      }
    }

    initAutoplay() {
      this.autoplaySpeed = this.dataset.speed * 1000;
      this.stepToMoveAutoplay = this.rtl ? -1 : 1;
      this.stopAutoplayWhenHover =
        this.dataset.stopAutoplayWhenHover !== "false";

      if (this.stopAutoplayWhenHover) {
        this.addEventListener("mouseover", this.pauseAutoplay.bind(this));
        this.addEventListener("mouseleave", this.resumeAutoplay.bind(this));
      }

      this.carousel.addEventListener("focusin", this.pauseAutoplay.bind(this));
      this.carousel.addEventListener("focusout", this.resumeAutoplay.bind(this));

      this.addObserver();
      this.startAutoplay();
    }

    startAutoplay() {
      if (this.autoplay) {
        this.timeoutId = setTimeout(() => {
          this.intervalId = setInterval(
            this.moveSlide.bind(this),
            this.autoplaySpeed,
            this.stepToMoveAutoplay
          );
        }, 500);
      }
    }

    pauseAutoplay() {
      clearTimeout(this.timeoutId);
      clearInterval(this.intervalId);
    }

    resumeAutoplay() {
      this.pauseAutoplay();
      this.startAutoplay();
    }

    /**
     * Adds an observer to pause autoplay when the slideshow is not in the viewport.
     */
    addObserver() {
      if ("IntersectionObserver" in window === false) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.resumeAutoplay();
          } else {
            this.pauseAutoplay();
          }
        });
      });

      observer.observe(this);
    }

    addListeners() {
      this.wheelHandler = this.handleWheel.bind(this);
      this.carouselOuter.addEventListener('wheel', this.wheelHandler);

      if (this.nav) {
        this.navClickHandler = this.handleNavClick.bind(this);
        this.nav.addEventListener("click", this.navClickHandler);
      }

      if (this.canDrag) {
        this.dragStartHandler = this.handleDragStart.bind(this);
        this.dragEndHandler = this.handleDragEnd.bind(this);
        this.dragHandler = this.handleDrag.bind(this);
        
        this.carouselOuter.addEventListener('touchstart', this.dragStartHandler, { passive: true });
        this.carouselOuter.addEventListener('touchend', this.dragEndHandler, { passive: true });      
        this.carouselOuter.addEventListener('touchmove', this.dragHandler, { passive: true });  
        
        this.carouselOuter.addEventListener("mousedown", this.dragStartHandler);
        this.carouselOuter.addEventListener("mouseup", this.dragEndHandler);
        this.carouselOuter.addEventListener("mouseleave", this.dragEndHandler);
        this.carouselOuter.addEventListener("mousemove", this.dragHandler);
        this.carouselOuter.addEventListener('dragstart', (evt) => { evt.preventDefault(); });
      }
    }

    removeListeners() {
      this.carouselOuter.removeEventListener("wheel", this.wheelHandler);
      this.nav.removeEventListener("click", this.navClickHandler);
      this.carouselOuter.removeEventListener("touchstart", this.dragStartHandler);
      this.carouselOuter.removeEventListener("touchend", this.dragEndHandler);
      this.carouselOuter.removeEventListener("touchmove", this.dragHandler);
      this.carouselOuter.removeEventListener("mousedown", this.dragStartHandler);
      this.carouselOuter.removeEventListener("mouseup", this.dragEndHandler);
      this.carouselOuter.removeEventListener("mouseleave", this.dragEndHandler);
      this.carouselOuter.removeEventListener("mousemove", this.dragHandler);
    }

    /**
     * Handles 'wheel' events on the carousel.
     * @param {object} evt - Event object.
     */
    handleWheel(evt) {
      if (this.blockWheelTrigger) {
        evt.preventDefault();
      } else if (evt.deltaX > 20) {
        evt.preventDefault();
        this.moveSlide(1);
        this.blockWheelTrigger = true;
        setTimeout(() => { this.blockWheelTrigger = false; }, 800);
      } else if (evt.deltaX < -20) {
        evt.preventDefault();
        this.moveSlide(-1);
        this.blockWheelTrigger = true;
        setTimeout(() => { this.blockWheelTrigger = false; }, 800);
      }
    }

    /**
     * Handles 'mousedown' or 'touchstart' events on the carousel element.
     * @param {object} evt - Event object.
     */
    handleDragStart(evt) {
      this.dragstart = true;
      this.mousemoved = false;
      this.carousel.style.transition = "none";
      this.carouselOuter.classList.add("is-grabbing");
      
      this.firstPos = this.currentPos = ( evt.type === "touchstart" ? evt.touches[0].clientX : evt.clientX ); //reset first and current position

      if (this.autoplay) {
        this.pauseAutoplay();
      }
    }

    // this function is used to check current index to determine move next or previous
    checkIndex(currentMove) {
      let temp = currentMove;
      while (temp >= this.step) {
        temp -= this.step;
      }
      if (
        (temp > 50 && this.firstPos - this.currentPos >= 0) ||
        (this.step - temp < 50 && this.firstPos - this.currentPos <= 0)
      )
        return Math.ceil(currentMove / this.step);
      return Math.floor(currentMove / this.step);
    }

    /**
     * Handles 'mouseup' or 'touchend' events on the carousel element.
     */
    handleDragEnd(evt) {
      this.dragstart = false;
      this.carouselOuter.classList.remove("is-grabbing");
      if (this.mousemoved) {
        evt.preventDefault();
        this.carouselOuter.classList.remove('is-dragging');
      }

      let currentMove = parseFloat(this.carousel.style.transform.slice(12));
      this.index = this.checkIndex(-currentMove);
      if (!this.loop) {
        if (this.index > this.numberOfItem - this.itemPerRow)
          this.index = this.numberOfItem - this.itemPerRow;
        if (this.index < 0) this.index = 0;
      }
      this.carousel.style.transition = "all 0.25s";
      this.translateSlide();
      if (this.autoplay) {
        this.resumeAutoplay();
      }
    }

    /**
     * Handles 'mousemove' or 'touchmove' events on the carousel element.
     * @param {object} evt - Event object.
     */
    handleDrag(evt) {
      if (!this.dragstart) return;
      if (evt.type == 'mousemove') {
        evt.preventDefault();
        this.mousemoved = true;
        this.carouselOuter.classList.add('is-dragging');
      }

      let currentMove = parseFloat(this.carousel.style.transform.slice(12)); //get the x-axis of transform3d
      let currentIndex = -currentMove / this.step;
      let x = evt.type === "touchmove" ? evt.touches[0].clientX : evt.clientX; //get current coordinate
      let distanceMoved = x - this.currentPos;
      if (this.loop) {
        if (currentIndex <= 0) {
          this.index = this.numberOfItem;
          this.translateSlide();
        } else if (currentIndex >= this.numberOfItem + this.itemPerRow) {
          this.index = this.itemPerRow;
          this.translateSlide();
        } else {
          this.carousel.style.transform = `translate3d(${
            currentMove + distanceMoved
          }px,0,0)`;
        }
      } else {
        if (
          currentIndex < 0 ||
          currentIndex > this.numberOfItem - this.itemPerRow
        )
          this.carousel.style.transform = `translate3d(${
            currentMove + distanceMoved / 5
          }px,0,0)`;
        //when user drag out of bound, decrease speed
        else
          this.carousel.style.transform = `translate3d(${
            currentMove + distanceMoved
          }px,0,0)`;
      }
      this.currentPos = x;
    }

    /**
     * Handles 'click' events on the nav buttons container.
     * @param {object} evt - Event object.
     */
    handleNavClick(evt) {
      if (!evt.target.matches(".loop-carousel-nav__btn")) return;

      if (
        (evt.target.name === "next" && !this.rtl) ||
        (evt.target.name === "prev" && this.rtl)
      ) {
        this.moveSlide(1);
      } else {
        this.moveSlide(-1);
      }

      if (this.autoplay) {
        this.resumeAutoplay();
      }
    }

    /**
     * Handles 'on:debounced-resize' events on the window.
     */
    handleResize() {
      let windowWidth = window.innerWidth;
      let flag = false;

      for (let property in this.responsive) {
        if (property >= windowWidth) {
          this.itemPerRow = this.responsive[property][0];
          this.itemWidth = this.responsive[property][1];
          flag = true;
          break;
        }
      }
      if (!flag) {
        //all property are smaller the window width, happen when we increase window width, reset these property to highest value
        this.itemPerRow = this.itemPerRowBig;
        this.itemWidth = this.itemWidthBig;
      }
      this.gapWidth =
        (100 - this.itemPerRow * this.itemWidth) / (this.itemPerRow - 1) || 0;
      this.style.setProperty("--width", `${this.itemWidth}%`);
      this.style.setProperty("--margin", `${this.gapWidth}%`);

      this.imgWidth = this.carouselItem[0].getBoundingClientRect().width;
      this.step =
        this.imgWidth + (this.gapWidth / this.itemWidth) * this.imgWidth;
      this.style.setProperty("--img-width", `${Math.round(this.imgWidth * 100) / 100}px`);
      //change important property for responsive

      if (!this.loop && (this.index + this.itemPerRow > this.numberOfItem) ) {
        this.index = this.numberOfItem - this.itemPerRow; // if the slide block is the last few items (to prevent showing empty spaces)
      }
      this.moveSlide(0);
      //fit carousel in correct position
    }

    /**
     * Sets the disabled state of the nav buttons.
     */
    setButtonStates() {
      if (!this.loop) {
        this.prevBtn.disabled = this.index == 0 || this.itemPerRow >= this.numberOfItem;
        this.nextBtn.disabled = (this.index + this.itemPerRow) == this.numberOfItem || this.itemPerRow >= this.numberOfItem;
      }
    }
  }

  customElements.define("loop-carousel", LoopCarousel);
}

